import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthenticationModel } from './authentication.model';
import { SignupModule } from './signup/signup.module';
import { LOGOUT_ROUTES } from './logout/routes';
import { NavigationBlockerLayoutModule } from './components/navigation-blocker-layout/navigation-blocker-layout.module';

@NgModule({
    imports: [SignupModule, RouterModule.forChild(LOGOUT_ROUTES), NavigationBlockerLayoutModule],
    providers: [AuthenticationModel]
})
export class AuthenticationModule {}
